import React, { PureComponent } from 'react';
import './App.css';
import { height } from '@fortawesome/free-solid-svg-icons/fa0';

const Visualization = ( {index,totalLength,totalWidth,totalThickness,FS,BLK,profile,LP,isOpen,setIsOpen}) => {
    const resizeFactor=600/totalLength;
    let blockLength;
    const [stackedLPS,setStackedLPS]=React.useState([]);
    const [stackedBLKS,setStackedBLKS]=React.useState([]);
    const findMaxLength=(arr)=>{
      return Math.max(...arr.map(slap=>slap.length))
    }
    if(profile=='FS+BLK'){
     blockLength= BLK[0]?.length;
    }

   React.useEffect(()=>{
      if(profile=='LP'&&LP){
        let temp=[];
        for(let i =0;i<LP.length;i=i+(totalWidth/LP[0]?.width)){
          temp.push(LP[i])
        }
        setStackedLPS(temp);
        let temp2=[];
        for(let i =0;i<BLK.length;i=i+Math.floor(totalWidth/BLK[0]?.length)){
          temp2.push(BLK[i])
        }
        setStackedBLKS(temp2);
      }
    },[])
    const MaxLength=findMaxLength(FS);
    return (
        profile=='FS+BLK'?(
        <>



             <div className='vis-container' >
              <div
               style={
                {
                  background:"#D7D2CB",

                  borderRadius:'10px',
                  height:'100px',
                  width:'150px',
                  position:'absolute',
                  top:'10px',
                  right:'10px',
                  display:'flex',
                  flexDirection:'column',
                  alignItems:'start',
                  justifyContent:'space-around',
                  padding:'5px',
                  paddingTop:'20px'

                }
               }
              >
               <div style={{margin:'5px'}}> <div style={{ background:'blue'
                ,height:'10px'
                ,width:'10px'
                ,borderRadius:'50%',
                 display:'inline-block'}}></div><p
                style={{
                  display:'inline-block',
                  marginLeft:'10px'
                }}
               > FS</p></div>
               <div style={{margin:'5px'}}> <div style={{ background:'orange'
                ,height:'10px'
                ,width:'10px'
                ,borderRadius:'50%',
                 display:'inline-block'}}></div><p
                style={{
                  display:'inline-block',
                  marginLeft:'10px'
                }}
               > BLK</p></div>


              </div>
             <div className="outer-rect"
             style={{height:`${resizeFactor*totalThickness}px`,

             width:`${resizeFactor*totalLength+8}px`,
             background:"#DAD4D4",
             border:"5px solid black",
             display:"flex",
             flexDirection:'row',
             position:'relative',
             justifyContent:'space-between',
             marginTop:'50px',

             }}>

             <div
              style={{
                position:'absolute',
                top:"-40px",
                minWidth:`${MaxLength*resizeFactor+3}px`,
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
                //width:'77%',
                borderRight:'2px solid black',
                borderLeft:'2px solid black',

              }}
             >
                <span style={{
                    width: '100%',
                    position: 'absolute',
                    /* z-index: -1; */
                    height: '2px',
                    background: 'black',
                }}/>
               <p style={{

                position: 'relative',
                bottom: '10px',
               }}>{MaxLength} mm</p>
             </div>
             <div style={{
                  display:"flex",
                  flexDirection:"column",
                  minWidth:`${MaxLength*resizeFactor+3}px`,
                  height:'100%',
                  border:"2px solid black",

                  backgroundImage:' repeating-linear-gradient(45deg, #00000033, #00000033 10px, transparent 10px, transparent 20px)',
                 // width:'77%'


             }}
             onClick={(e)=>{setIsOpen(true)}}>
             {FS.map(slap=>(
             <div style={{
                display:'flex',
                border:"1px solid black",
                background:"blue",

                height:`${resizeFactor*slap.thickness}px`,
                width:`${resizeFactor*slap.length}px`,
                alignItems:'center',
                justifyContent:'center',
             }}
             onClick={(e)=>{e.stopPropagation()}}
             ><p style={{
                margin:'0',
                color:"white",
                fontSize:'0.8rem'
             }}>{slap.length} mm</p></div>
             ))}
             </div>
             <div
              style={{
                position:'absolute',
                top:"-40px",
                right:'-5px',
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
                width:`${(totalLength-MaxLength)*resizeFactor +2}px`,
                borderRight:'2px solid black',
                borderLeft:'2px solid black',

              }}
             >
                <span style={{
                    width: '100%',
                    position: 'absolute',
                    right:'0',
                    /* z-index: -1; */
                    height: '2px',
                    background: 'black',
                }}/>
               <p style={{

                position: 'relative',
                bottom: '10px',

               }}>{(totalLength-MaxLength)} mm</p>
             </div>
             <div style={{

                    display:"flex",
                    //flexDirection:"column",
                    flexWrap:'wrap',
                    alignItems:'end',
                    alignContent:'flex-start',
                    transform:'rotateY(180Deg)',


            }}>
             {
               BLK.map(block=>(<div
               style={{


                   position:'relative',
                   height:`${resizeFactor*block.thickness}px`,
                   width:`${resizeFactor*block.length}px`,
                   border:`1px solid black`,
                   background:`orange`
               }}
               ></div>))
             }
            </div>
             </div>

             </div>

        </>
        ):(<>
         <div className='table-bg  p-4 mt-3 m-1 ' style={{

          }}>
             <h2>Visualization {`${index}`} </h2>
             <div className='vis-container' >
             <div
               style={
                {
                  background:"#D7D2CB",

                  borderRadius:'10px',
                  height:'100px',
                  width:'150px',
                  position:'absolute',
                  top:'10px',
                  right:'10px',
                  display:'flex',
                  flexDirection:'column',
                  alignItems:'start',
                  justifyContent:'space-around',
                  padding:'5px'

                }
               }
              >
               <div style={{margin:'5px'}}> <div style={{
                background:'red'
                ,height:'10px'
                ,width:'10px'
                ,borderRadius:'50%',
                 display:'inline-block'}}></div><p
                style={{
                  display:'inline-block',
                  marginLeft:'10px'
                }}
               > LP</p></div>



              </div>
             <div
               style={
                {
                  background:"#D7D2CB",

                  borderRadius:'10px',
                  height:'100px',
                  width:'150px',
                  position:'absolute',
                  top:'10px',
                  right:'10px',
                  display:'flex',
                  flexDirection:'column',
                  alignItems:'start',
                  justifyContent:'space-around',
                  padding:'5px'

                }
               }
              >
               <div style={{margin:'5px'}}> <div style={{ background:'#46A3EC'
                ,height:'10px'
                ,width:'10px'
                ,borderRadius:'50%',
                 display:'inline-block'}}></div><p
                style={{
                  display:'inline-block',
                  marginLeft:'10px'
                }}
               > LP</p></div>



              </div>
             <div className="outer-rect"

             style={{height:`${resizeFactor*totalThickness+10}px`,
             cursor:'pointer',

             width:`${resizeFactor*totalLength}px`,
             background:"#DAD4D4",
             border:"5px solid black",
             display:"flex",
             flexDirection:'row',
             position:'relative',
             justifyContent:'space-between',
             backgroundImage:' repeating-linear-gradient(45deg, #00000033, #00000033 10px, transparent 10px, transparent 20px)',
             }}>

      {/**

       <div
              style={{
                position:'absolute',
                top:"-40px",
                width: `${stackedLPS.length>totalThickness/LP[0].thickness?((totalLength-(totalLength%LP[0].length))*resizeFactor):(LP[0].length*resizeFactor)}px`,
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
                //width:'77%',
                borderRight:'2px solid black',
                borderLeft:'2px solid black',

              }}
             >
                <span style={{
                    width: '100%',
                    position: 'absolute',
                     z-index: -1;
                    height: '2px',
                    background: 'black',
                }}/>
               <p style={{
                zIndex: '2',
                position: 'relative',
                bottom: '10px',
               }}>{stackedLPS.length>totalThickness/LP[0].thickness?((totalLength-(totalLength%LP[0].length))):(LP[0].length)} mm</p>
             </div>
       */}
            <div style={{
  display: "flex",
  flexDirection: "column",
  flexWrap: 'wrap',
  height: '100%',
}}>
  {stackedLPS.map(slap => (
    <div style={{
      display: 'flex',
      border: "1px solid black",
      background: "#46A3EC",
      height: `${resizeFactor * slap.thickness}px`,
      width: `${resizeFactor * slap.length}px`,
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <p style={{
        margin: '0',
        color: "white",
        fontSize: '0.8rem'
      }}>{slap.length} mm</p>
    </div>
  ))}
  <div style={{
    display: 'flex',
    width: '26%',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',  // Change justifyContent to 'flex-start'
    alignItems: 'flex-start',
    flexWrap: "wrap"
  }}>
    {stackedBLKS.map(BLK => (
      <div style={{
        display: 'flex',
        border: "1px solid black",
        background: "orange",
        height: `${resizeFactor * BLK.thickness}px`,
        width: `${resizeFactor * BLK.width}px`,
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <p style={{
          margin: '0',
          color: "white",
          fontSize: '0.8rem'
        }}>{BLK.width} mm</p>
      </div>
    ))}
  </div>
</div>

             </div>

             </div>
          </div>
        </>)
)}





export default Visualization;